/**
 * @file
 * Placeholder file for custom sub-theme behaviors.
 *
 */
(function($, Drupal) {
  "use strict";

  /**
   * @type {{attach: Drupal.behaviors.pppVideos.attach}}
   */
  Drupal.behaviors.pppVideos = {
    attach : function(context, settings) {
      var locale = settings.pppTheme.global.locale;
      var i18n = {
        en : {
          restart : 'Restart',
          rewind : 'Rewind {seektime} secs',
          play : 'Play',
          pause : 'Pause',
          fastForward : 'Forward {seektime} secs',
          seek : 'Seek',
          played : 'Played',
          buffered : 'Buffered',
          currentTime : 'Current time',
          duration : 'Duration',
          volume : 'Volume',
          mute : 'Mute',
          unmute : 'Unmute',
          enableCaptions : 'Enable captions',
          disableCaptions : 'Disable captions',
          enterFullscreen : 'Enter fullscreen',
          exitFullscreen : 'Exit fullscreen',
          frameTitle : 'Player for {title}',
          captions : 'Captions',
          settings : 'Settings',
          speed : 'Speed',
          normal : 'Normal',
          quality : 'Quality',
          loop : 'Loop',
          start : 'Start',
          end : 'End',
          all : 'All',
          reset : 'Reset',
          disabled : 'Disabled',
          advertisement : 'Ad'
        },
        fr : {
          restart : 'Relancer',
          rewind : 'Reculer de {seektime} secs',
          play : 'Lire',
          pause : 'Pause',
          fastForward : 'Avancer de {seektime} secs',
          seek : 'Rechercher',
          played : 'Joué',
          buffered : 'Tamponnée',
          currentTime : 'Temps actuel',
          duration : 'Durée',
          volume : 'Volume',
          mute : 'Désactiver le son',
          unmute : 'Activer le son',
          enableCaptions : 'Activer les sous-titres',
          disableCaptions : 'Désactiver les sous-titres',
          enterFullscreen : 'Entrer en plein écran',
          exitFullscreen : 'Sortir du plein écran',
          frameTitle : 'Lecteur pour {title}',
          captions : 'Sous-titres',
          settings : 'Paramètres',
          speed : 'Vitesse',
          normal : 'Normal',
          quality : 'Qualité',
          loop : 'Bouble',
          start : 'Début',
          end : 'Fin',
          all : 'Tout',
          reset : 'Réinitialiser',
          disabled : 'Désactivé',
          advertisement : 'Publicité'
        },
        'zh-hans' : {
          restart : '重新启动',
          rewind : '倒带 {seektime} 秒',
          play : '玩',
          pause : '暂停',
          fastForward : '前进 {seektime} 秒',
          seek : '寻找',
          played : '玩过',
          buffered : '缓冲',
          currentTime : '当前时间',
          duration : '持续时间',
          volume : '音量',
          mute : '静音',
          unmute : '取消静音',
          enableCaptions : '启用字幕',
          disableCaptions : '禁用字幕',
          enterFullscreen : '输入全屏',
          exitFullscreen : '退出全屏',
          frameTitle : '玩家为 {title}',
          captions : '字幕',
          settings : '设置',
          speed : '速度',
          normal : '正常',
          quality : '质量保证',
          loop : '循环',
          start : '开始',
          end : '结束',
          all : '全部',
          reset : '重置',
          disabled : '残疾人',
          advertisement : '广告'
        }
      };

      function Player(options) {
        this.element = $(options.element);
        this.isYoutubeEnabled = options.isYoutubeEnabled || false;
        this.isYoutubeReachable = options.isYoutubeReachable || false;
        this.isDailymotionEnabled = options.isDailymotionEnabled || false;
        this.isDailymotionReachable = options.isDailymotionReachable || false;
        this.title = 'Une vidéo';
        this.plyrInstance = undefined;
        this.embedPlayer = false;
        this.embedType = undefined;
        this.embedUrl = undefined;
        this.embedId = undefined;
        this.localPlayer = false;
        this.localUrl = undefined;
        this.localExtension = undefined;
        this.UUID = Math.random().toString(36).substr(2, 9);
      }

      Player.prototype.init = function() {
        this.title = this.element.data('title');
        this.embedUrl = this.element.data('embedUrl');
        this.findEmbedType();
        this.localUrl = this.element.data('localUrl');
        this.localExtension = this.element.data('localExtension');
        this.updatePlayer();
      };

      Player.prototype.findEmbedType = function() {
        if (this.embedUrl) {
          var matchYoutube = this.embedUrl.match(
            /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be|youtube\.com|y2u\.be)(?:\/)(?:embed\/|v\/|watch\?v=|watch\?.+&v=)?((\w|-){11})(?:\S+)?$/);
          if (matchYoutube) {
            this.embedType = 'youtube';
            this.embedId = matchYoutube[1];
          } else {
            var matchDailymotion = this.embedUrl.match(
              /^(?:https?:\/\/)?(?:www\.)?(?:dailymotion\.com|dail.ly)\/(?:video|hub)\/([^_]+)(?:[^#])*(?:#video=([^_&]+))?/i);
            if (matchDailymotion) {
              this.embedType = 'dailymotion';
              this.embedId = matchDailymotion[2] ? matchDailymotion[2] : matchDailymotion[1];
            }
          }
        }
      };

      Player.prototype.update = function(options) {
        this.isYoutubeEnabled = options.isYoutubeEnabled || false;
        this.isYoutubeReachable = options.isYoutubeReachable || false;
        this.isDailymotionEnabled = options.isDailymotionEnabled || false;
        this.isDailymotionReachable = options.isDailymotionReachable || false;
        this.updatePlayer();
      };

      Player.prototype.updatePlayer = function() {
        if ((this.isYoutubeEnabled && this.isYoutubeReachable && this.embedType === 'youtube') ||
          (this.isDailymotionEnabled && this.isDailymotionReachable && this.embedType === 'dailymotion')
        ) {
          if (!this.embedPlayer) {
            this.destroyPlayer();
            if (this.embedType === 'youtube') {
              this.createPlayerYoutube();
            } else if (this.embedType === 'dailymotion') {
              this.createPlayerDailymotion();
            }
          }
        } else {
          if (!this.localPlayer) {
            this.destroyPlayer();
            this.createPlayerLocal();
          }
        }
      };

      Player.prototype.destroyPlayer = function() {
        if (this.plyrInstance) {
          this.plyrInstance.destroy();
          this.plyrInstance = undefined;
        }
        $('#ppp-player-' + this.UUID).remove();
        this.embedPlayer = false;
        this.localPlayer = false;
      };

      Player.prototype.createPlayerDailymotion = function() {
        if (this.embedId) {
          this.embedPlayer = true;
          var html = '<iframe id="ppp-player-' + this.UUID + '" allowfullscreen ' +
            'src="//www.dailymotion.com/embed/video/' + this.embedId +
            '?origin=' + encodeURIComponent(window.location.href) +
            '&queue-autoplay-next=false&queue-enable=false&sharing-enable=false" title="' + this.title + '"></iframe>';
          this.element.append(html);
          this.hidePlayerNotAvailable();
        } else {
          this.createPlayerLocal();
        }
      };

      Player.prototype.createPlayerYoutube = function() {
        if (this.embedId) {
          this.embedPlayer = true;
          let html = '<iframe id="ppp-player-' + this.UUID + '" allowfullscreen ' +
            'src="//www.youtube.com/embed/' + this.embedId +
            '?origin=' + encodeURIComponent(window.location.href) +
            '&queue-autoplay-next=false&queue-enable=false&sharing-enable=false" title="' + this.title + '"></iframe>';
          this.element.append(html);
          this.hidePlayerNotAvailable();
        } else {
          this.createPlayerLocal();
        }
      };

      Player.prototype.createPlayerLocal = function() {
        if (this.localUrl) {
          this.localPlayer = true;
          var html = '';
          html += '<video id="ppp-player-' + this.UUID + '" playsinline controls>';
          html += '  <source src="' + this.localUrl + '" type="video/' + this.localExtension + '"/>';
          html += '</video>';
          this.element.append(html);
          this.plyrInstance = new window.Plyr('#ppp-player-' + this.UUID, {
            title : this.title,
            i18n : i18n[locale]
          });
          this.hidePlayerNotAvailable();
        } else {
          this.showPlayerNotAvailable();
        }
      };

      Player.prototype.showPlayerNotAvailable = function() {
        this.element.children(
          '.youtube-disable, .youtube-not-reachable, .dailymotion-disable, .dailymotion-not-reachable'
        ).addClass('hidden');
        this.element.removeClass('hidden');
        $('#ppp-player-' + this.UUID).addClass('hidden');
        if (this.embedType === 'youtube') {
          if (this.isYoutubeReachable) {
            this.element.children('.youtube-disable').removeClass('hidden');
          } else {
            this.element.children('.youtube-not-reachable').removeClass('hidden');
          }
        } else if (this.embedType === 'dailymotion') {
          if (this.isDailymotionReachable) {
            this.element.children('.dailymotion-disable').removeClass('hidden');
          } else {
            this.element.children('.dailymotion-not-reachable').removeClass('hidden');
          }
        } else {
          this.element.addClass('hidden');
        }
      };

      Player.prototype.hidePlayerNotAvailable = function() {
        this.element.removeClass('hidden');
        this.element.children(
          '.youtube-disable, .youtube-not-reachable, .dailymotion-disable, .dailymotion-not-reachable'
        ).addClass('hidden');
        $('#ppp-player-' + this.UUID).removeClass('hidden');
      };

      window.pppVideosInterface = {
        isInit : false,
        players : [],
        isYoutubeTestedOnce : false,
        isYoutubeReachable : false,
        isYoutubeEnabled : false,
        isDailymotionTestedOnce : false,
        isDailymotionReachable : false,
        isDailymotionEnabled : false,

        init : function(target) {
          if (!this.isInit) {
            this.isInit = true;
            this.askTamForCookie();
            setTimeout(function() {
              $(target).each(function() {
                window.pppVideosInterface.createPlayer(this);
              });
            }, 1000);
          }
        },

        createPlayer : function(element) {
          var player = new Player({
            element : element,
            isYoutubeEnabled : this.isYoutubeEnabled,
            isYoutubeReachable : this.isYoutubeReachable,
            isDailymotionEnabled : this.isDailymotionEnabled,
            isDailymotionReachable : this.isDailymotionReachable
          });
          player.init();
          this.players.push(player);
        },

        updatePlayers : function() {
          this.players.forEach(function(player) {
            player.update({
              isYoutubeEnabled : this.isYoutubeEnabled,
              isYoutubeReachable : this.isYoutubeReachable,
              isDailymotionEnabled : this.isDailymotionEnabled,
              isDailymotionReachable : this.isDailymotionReachable
            });
          }.bind(this));
        },

        askTamForCookie : function() {
          if (window.tartealamyrtille && window.tartealamyrtille.readCookie('youtube')) {
            this.enableYoutube();
          } else {
            this.testYoutube(
              function() {
                this.disableYoutube();
              }.bind(this)
            );
          }
          if (window.tartealamyrtille && window.tartealamyrtille.readCookie('dailymotion')) {
            this.enableDailymotion();
          } else {
            this.testDailymotion(
              function() {
                this.disableDailymotion();
              }.bind(this)
            );
          }
        },

        enableYoutube : function() {
          this.testYoutube(
            function() {
              this.isYoutubeEnabled = true;
              this.updatePlayers();
            }.bind(this),
            this.disableYoutube.bind(this)
          );
        },

        disableYoutube : function() {
          this.isYoutubeEnabled = false;
          this.updatePlayers();
        },

        enableDailymotion : function() {
          this.testDailymotion(
            function() {
              this.isDailymotionEnabled = true;
              this.updatePlayers();
            }.bind(this),
            this.disableDailymotion.bind(this)
          );
        },

        disableDailymotion : function() {
          this.isDailymotionEnabled = false;
          this.updatePlayers();
        },

        testYoutube : function(success, error, callback) {
          var image = $(
            '<img src="https://www.youtube.com/favicon.ico?uuid=' + Math.random().toString(36).substr(2, 15) +
            '" style="display: none;" />');
          this.testImage(image, function() {
            this.isYoutubeReachable = true;
            if (success && typeof success === typeof Function) {
              success();
            }
            if (callback && typeof callback === typeof Function) {
              callback();
            }
          }.bind(this), function() {
            this.isYoutubeReachable = false;
            if (error && typeof error === typeof Function) {
              error();
            }
            if (callback && typeof callback === typeof Function) {
              callback();
            }
          }.bind(this));
        },

        testDailymotion : function(success, error, callback) {
          var image = $(
            '<img src="https://www.dailymotion.com/favicon.ico?uuid=' + Math.random().toString(36).substr(2, 15) +
            '" style="display: none;" />');
          this.testImage(image, function() {
            this.isDailymotionReachable = true;
            if (success && typeof success === typeof Function) {
              success();
            }
            if (callback && typeof callback === typeof Function) {
              callback();
            }
          }.bind(this), function() {
            this.isDailymotionReachable = false;
            if (error && typeof error === typeof Function) {
              error();
            }
            if (callback && typeof callback === typeof Function) {
              callback();
            }
          }.bind(this));
        },

        testImage : function(image, success, error) {
          image.on('load', function() {
            image.remove();
            if (success && typeof success === typeof Function) {
              success();
            }
          }).on('error', function() {
            image.remove();
            if (error && typeof error === typeof Function) {
              error();
            }
          });

          $("body").append(image);
        }
      };

      $(document).ready(function() {
        $(once('videoBehavior', '.media-video-plyr')).each(function() {
          window.pppVideosInterface.init(".media-video-plyr");
        });
      });
    }
  };
})(jQuery, window.Drupal);
